<template>
  <div class="blase-result">
    <Aheader :realIndex="3"></Aheader>
    <div class="banner">
      <div>
        <p>Search for the highest similarity for your sequence of interest.</p>
      </div>
    </div>
    <div class="path">
      <router-link to="/blast">Blast</router-link>
      <span style="color:#999"> / </span>
      <span> Submit Results </span>
      <div class="dropdown">
        <el-select
          v-model="value"
          @change="selectChange"
          placeholder="Please select"
        >
          <el-option
            v-for="(item, index) in queryTitleList"
            :key="index"
            :label="item"
            :value="item"
            style="padding-left:10px;font-size: 16px;width:216px"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div>
      <div
        v-if="loading"
        style="height:200px;z-index:1999"
        v-loading.lock="loading"
        element-loading-text="Data loading"
        element-loading-spinner="el-icon-loading"
      ></div>
      <div
        id="classification-results"
        v-if="isShow"
      >
        <!-- <el-empty description="Blast结果"></el-empty> -->
        <div>
          <div class="le content">
            <div class="line">
              <div class="le-title">Query_title:</div>
              <div class="ri-content">{{ queryName }}</div>
            </div>
            <div class="line">
              <div class="le-title">Database Name:</div>
              <div class="ri-content">{{ dbname }}</div>
            </div>
            <div class="line">
              <div class="le-title">Molecule Type:</div>
              <div class="ri-content">nucleic acid</div>
            </div>
          </div>
          <div class="ri content">
            <div class="line">
              <div class="le-title">Program:</div>
              <div class="ri-content">{{ program }}</div>
            </div>

            <div class="line">
              <div class="le-title">Query Length:</div>
              <div class="ri-content">{{ queryLen }}</div>
            </div>
            <div class="line">
              <div class="le-title">Version:</div>
              <div class="ri-content">{{ version }}</div>
            </div>
          </div>
        </div>
        <div class="el-bot">
          <el-button
            class="zip-bot"
            @click="downloadStrain('zip')"
          ><img
              src="../../assets/img/blast-download.svg"
              alt=""
            />
            ZIP</el-button>
          <el-button
            class="zip-bot"
            @click="downloadStrain('csv')"
          ><img
              src="../../assets/img/blast-download.svg"
              alt=""
            />CSV</el-button>
            <el-button
            class="zip-bot"
            @click="downloadTableFile"
          ><img
              src="../../assets/img/blast-download.svg"
              alt=""
            />TABLE</el-button>
        </div>
        <div
          style="margin: 15px 0 150px"
          v-if="qulity.datas !== undefined && qulityShow"
        >
          <rep-table
            ref="blash"
            :retinue="retinue"
            :select="true"
            :openPage="true"
            :tableData="qulity"
          ></rep-table>
        </div>
      </div>
      <div
        v-if="!loading && !isShow"
        class="no-data"
      >
        <img
          src="../../assets/img/no-data.svg"
          alt=""
        />
        <p>No data</p>
      </div>
    </div>
    <Afooter></Afooter>
  </div>
</template>

<script>
import Aheader from '../../components/aheader.vue'
import http from '../../utils/http'
import api from '../../utils/api'
import { Message } from 'element-ui'
import Afooter from '../../components/afooter.vue'
import util from '../../utils/report'
import RepTable from '../../components/gos-virusdb-report-table.vue'
export default {
  name: 'BlaseResult',
  components: {
    Aheader,
    RepTable,
    Afooter
  },
  data () {
    return {
      isShow: false,
      blastResult: {},
      queryTitleList: [],
      value: '',
      valueIndex: 0,
      name: '',
      qulityShow: false,
      // 导出csv和zip需要用到两个id
      libid: '',
      tableid: '',
      queryName: '',
      dbname: '',
      queryLen: '',
      program: '',
      version: '',
      qulity: {},
      curQueryPosObj: {},
      curStanardFeatureData: '',
      curlineDataPositions: {},
      retinue: {},
      // 导出Tabular地址
      outputFileTabular: '',
      // 导出Asn地址
      outputFileAsn: '',
      loading: true,
      // 定时器
      timer: null,
      // 文件下载
      assembly: '',
      sampleName: 'table.csv'
    }
  },
  created () {
    this.$store.commit('toTop')
    this.timer = setInterval(() => {
      this.getData()
    }, 1000)
  },
  mounted () { },
  methods: {
    // 下载表格文件csv
    downloadTableFile () {
      let element = document.createElement('a')
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.assembly))
      element.setAttribute('download', this.sampleName)
      element.style.display = 'none'
      element.click()
    },
    selectChange () {
      this.valueIndex = this.queryTitleList.indexOf(this.value)
      this.renderBlast()
    },
    getData () {
      api.getCmdGroupTasks(this.$route.query.taskGroupId).then(res => {
        if (res.data.code === 0) {
          for (let i in res.data.data.member) {
            if (res.data.data.member[i].state === 'Success') {
              if (res.data.data.member[i].result.length !== 0) {
                this.blastResult = res.data.data.member[i]
                this.renderBlast()
              } else {
                this.loading = false
                this.isShow = false
                this.$message.error('The analysis report result is incorrect')
              }
              clearInterval(this.timer)
            } else if (res.data.data.member[i].state !== 'Success' && res.data.data.member[i].state !== 'Running') {
              this.$message.error('Error parsing report results')
              this.loading = false
              this.isShow = false
              clearInterval(this.timer)
            }
          }
        } else {
          this.loading = false
          this.isShow = false
          clearInterval(this.timer)
          this.$message.error(`${res.data.msg}`)
        }
      }).catch(req => {
        this.loading = false
        this.isShow = false
        clearInterval(this.timer)
        this.$message.error(`${req}`)
      })
    },
    // 获取Query_title的值 （值为一个数组）
    getBlastSeqIds (blastRecord) {
      let resultData = JSON.parse(blastRecord.result)
      if (resultData.output_json.startsWith('{')) {
        let outJson = JSON.parse(resultData.output_json)
        var outputJsonRootPath = outJson.outputJsonRootPath
        http.get(
          '/base/readWebDataContain' +
          outputJsonRootPath +
          '/' +
          outJson.indexJson,
          {},
          res => {
            if (res.code === 200) {
              let indexJson = JSON.parse(res.data)
              let sdata = []
              let list = []
              for (let i in indexJson) {
                list.push(indexJson[i].seqName)
                this.queryTitleList.push(indexJson[i].seqName)
                this.value = list[this.valueIndex]
                sdata.push({ seqid: indexJson[i].seqName, seqIndex: i })
              }
              this.queryTitleList = list
              // callback(sdata)
            }
          }
        )
      } else {
        http.get(
          '/base/readWebDataContain' + resultData.output_json,
          {},
          res => {
            if (res.code === 200) {
              let indexJson = JSON.parse(res.data)
              let sdata = []
              for (let i in indexJson) {
                this.queryTitleList.push(indexJson[i].seqName)
                sdata.push({ seqid: indexJson[i].seqName, seqIndex: i })
              }
              // callback(sdata)
            }
          }
        )
      }
    },
    // text路径，fileName文件名
    _downloadFile (text, fileName) {
      let element = document.createElement('a')
      element.setAttribute('href', text)
      element.setAttribute('download', fileName)
      element.style.display = 'none'
      element.click()
    },
    renderBlast () {
      if (this.blastResult.libraryId !== undefined) {
        this.renderBlastDb(this.blastResult.libraryId)
        this.getBlastSeqIds(this.blastResult)
        let resultJson = JSON.parse(this.blastResult.result)
        this.renderBlastResult(this.blastResult.libraryId, resultJson, 0)
      }
      // this.renderBlastDb(this.blastRecord.libraryId)
      // let resultJson = JSON.parse(this.blastResult.result)
      // this.renderBlastResult(this.blastRecord.libraryId, resultJson)
    },
    renderBlastResult (libid, resultData) {
      if (resultData.tabular_position) {
        let obj = JSON.parse(resultData.tabular_position)
        this.curQueryPosObj = {}
        for (let key in obj) {
          this.curQueryPosObj[key] = this.getMaxMinPositionRegion(obj[key])
        }
      }
      if (resultData.output_json.startsWith('{')) {
        this.renderBlastResultByMultiSeq(libid, resultData)
      } else {
        // Deprecated
        // renderBlastResultBySingleJson(libid, resultData)
      }
    },
    renderBlastResultByMultiSeq (libid, resultData) {
      var outJson = JSON.parse(resultData.output_json)
      var outputJsonRootPath = outJson.outputJsonRootPath
      http.get(
        `/base/readWebDataContain${outputJsonRootPath}/${outJson.indexJson}`,
        {},
        res => {
          if (res.code === 200) {
            var indexJson = JSON.parse(res.data)
            // var showids = this.$route.query['blastseqid']
            var showids = this.queryTitleList[this.valueIndex]
            showids = decodeURIComponent(showids)
            let paths = []
            if (showids && showids !== 'undefined') {
              for (let j in indexJson) {
                if (indexJson[j].seqName === showids) {
                  paths.push(outputJsonRootPath + '/' + indexJson[j].resultJson)
                  break
                }
              }
            } else {
              paths = [outputJsonRootPath + '/' + indexJson[1].resultJson]
            }
            this.getArrResultJson(paths, libid, resultData)
          }
        }
      )
    },
    getStandardMsg (libraryId, callback) {
      http.get(
        `/base/getSeqBaseBlastMetaData?libraryid=${libraryId}`,
        {},
        res => {
          if (res.code === 200 && res.data) {
            var name = res.data.standardSeqName
            name = name.startsWith('Standard')
              ? name.substring('Standard'.length)
              : name
            http.get(
              `/virusdb/getgbentitychilds?child=featrue&accession=${name}`,
              {},
              resp => {
                if (resp.code === 200) {
                  callback(name, resp.data)
                } else {
                  callback(name)
                }
              }
            )
          }
        }
      )
    },
    getStandardAndRender (libid, resultData, resultArr) {
      this.getStandardMsg(libid, (name, data) => {
        if (data) {
          this.curStanardFeatureData = data
          this.curlineDataPositions = name === 'NC_001802' ? { 4: 2, 6: 2 } : {}
        }
        this.renderBResult(
          libid,
          resultArr,
          resultData.outputFile_tabular,
          resultData.outputFile_asn,
          resultData.path
        )
      })
    },
    renderBResult (
      libid,
      resultArr,
      outputFileTabular,
      outputFileAsn,
      resultPath
    ) {
      this.outputFileTabular = outputFileTabular
      this.outputFileAsn = outputFileAsn
      let k = 0
      let seqname = resultArr[k].report.results.search.query_title
      let skeyindex = seqname.indexOf(' ')
      let skey = skeyindex > 0 ? seqname.substring(0, skeyindex) : seqname
      let queryPos = this.curQueryPosObj[skey]
      let resJson = resultArr[k]
      let report = resJson.report
      let results = resJson.report.results
      let searchRes = results.search
      let program = report.program
      let version = report.version
      let dbnameArr = report.search_target.db.split('/')
      let dbname = dbnameArr[dbnameArr.length - 1]
      let queryName = searchRes.query_title
      let queryLen = searchRes.query_len
      let hits = searchRes.hits
      let stat = searchRes.stat
      let tableid = 'paired-table-' + k
      this.isShow = true
      this.renderResultTitle(queryName, queryLen, dbname, program, version)
      this.renderResultTable(libid, tableid, hits, queryLen, stat, queryPos)
      this.loading = false
    },
    renderResultTitle (queryName, queryLen, dbname, program, version) {
      this.queryName = queryName
      this.dbname = dbname
      this.queryLen = queryLen
      this.program = program
      this.version = version
    },
    getArrResultJson (paths, libid, resultData) {
      let len = paths.length
      let result = []
      for (let i in paths) {
        http.get(`/base/readWebDataContain${paths[i]}`, {}, res => {
          if (res.code === 200) {
            result.push(JSON.parse(res.data))
            if (result.length === len) {
              this.getStandardAndRender(libid, resultData, result)
            }
          }
        })
      }
    },
    getMaxMinPositionRegion (str) {
      if (!str || str.indexOf(',') < 0) {
        return [0, 0]
      }
      str = str.replace('"', '')
      let arrs = str.split(';')
      let min = 0
      let max = 0
      for (let i in arrs) {
        let arr = arrs[i].split(',')
        let st = parseInt(arr[0])
        let et = parseInt(arr[1])
        if (min === 0) {
          min = st
        }
        if (min > st) {
          min = st
        }
        if (max < et) {
          max = et
        }
      }
      return [min, max]
    },
    renderBlastDb (dbid) {
      http.get(`/base/getSeqBaseLibrary`, {}, res => {
        if (res.code === 200) {
          for (let i in res.data) {
            if (res.data[i].id === dbid) {
              this.name = res.data[i].name
              break
            }
          }
        }
      })
    },
    renderResultTable (libid, tableid, hits, queryLen, stat, queryPos) {
      this.libid = libid
      this.tableid = tableid
      let descriptionArray = []
      for (var i in hits) {
        var hit = hits[i]
        var desArray = hit.description
        for (var j in desArray) {
          let des = desArray[j]
          let country
          let samplingDate
          let lineage = ''
          let accession = ''
          var strainSrt = des.id
          var strainArr = strainSrt.split('__')
          var cstrain = strainArr[0]
          if (cstrain.indexOf('/') !== -1) {
            var cstrainFields = cstrain.split('/')
            if (cstrainFields.length >= 4) {
              lineage = cstrainFields[0]
              country = cstrainFields[1]
              accession = cstrainFields[cstrainFields.length - 2]
              samplingDate = cstrainFields[cstrainFields.length - 1]
            }
          } else {
            accession = cstrain
          }
          let maxScore = 0
          let totalScore = 0
          let gaps = 0
          let evalue = 0
          let identLen = 0
          let alignLen = 0
          let hsps = hit.hsps
          for (var k in hsps) {
            if (hsps[k].bit_score > maxScore) {
              maxScore = hsps[k].bit_score
              evalue = hsps[k].evalue
              gaps = hsps[k].gaps
              identLen = hsps[k].identity
              alignLen = hsps[k].align_len
            }
            totalScore += hsps[k].bit_score
          }
          des = {
            id: des.id,
            description: des.title,
            max_score: maxScore.toFixed(2),
            totalScore: totalScore,
            evalue: evalue,
            query_cover: (alignLen / queryLen * 100).toFixed(3) + '%',
            ident: (identLen / alignLen * 100).toFixed(3) + '%',
            gaps: gaps,
            accession: accession,
            country: country,
            sampling_date: samplingDate,
            lineage: lineage,
            cstrain: cstrain
          }
          des.flag = util._covid19_lineage_info
            .filter(info => this.judge(info, des))
            .map(info => info.flag)[0]
          descriptionArray.push(des)
        }
      }

      let strainStrs = ''
      for (var q = 0; q < descriptionArray.length; q++) {
        descriptionArray[q].indexId = q
        if (descriptionArray[q].accession) {
          strainStrs += descriptionArray[q].cstrain + ','
        }
      }
      if (strainStrs !== '') {
        strainStrs = strainStrs.substring(0, strainStrs.length - 1)
      }
      if (strainStrs !== '') {
        http.post(
          `/virusdb/query?page=0&limit=0`,
          { first_accession: strainStrs },
          res => {
            if (res.code === 0) {
              var sdata = res.data
              for (var i in descriptionArray) {
                for (var j in sdata) {
                  if (
                    sdata[j].firstAccession === descriptionArray[i].accession
                  ) {
                    descriptionArray[i].organism = sdata[j].organism
                    descriptionArray[i].subtype = sdata[j].subtype
                    descriptionArray[i].lineage = sdata[j].lineage
                    break
                  }
                }
              }
            }
            this.getArchiveMsg(strainStrs, libid, posMsg => {
              this.renderTable(
                descriptionArray,
                posMsg,
                tableid,
                hits,
                queryPos
              )
            })
          }
        )
      } else {
        this.renderTable(descriptionArray, null, tableid, hits, queryPos)
      }
    },
    getArchiveMsg (names, libid, callback) {
      if (this.program === 'blastp') {
        var namesField = names.split(',')
        for (var i = 0; i < namesField.length; i++) {
          namesField[i] = namesField[i].substr(
            0,
            namesField[i].lastIndexOf('_')
          )
        }
        names = namesField.join(',')
      }
      this.$axios
        .post('/base/getSeqBaseBlastArchiveResult?libraryid=' + libid, names, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(res => {
          if (res.data.code === 200) {
            var data = res.data.data
            var posMsg = []
            for (var i in data) {
              posMsg[data[i].name] = this.getMaxMinPositionRegion(
                data[i].result
              )
            }
            callback(posMsg)
          }
        })
    },
    downloadStrain (type) {
      if (this.$refs.blash.multipleSelection.length === 0) {
        Message({
          message: 'Please select at least one strain',
          type: 'info'
        })
      } else {
        let sdata = this.$refs.blash.multipleSelection
        let nameList = sdata.map(d => d.id)
        let downloadType = type === 'zip' ? 'strain' : 'csv'
        let databaseType = this.dbname === 'nucl_cds_BLASTDB' ? 'cds' : (this.dbname === 'prot_BLASTDB' ? 'protein' : 'genome')
        this.$message.success('Downloading...')
        api.downloadSeqBaseArchiveData(this.libid, downloadType, databaseType, nameList).then((response) => {
          if (response.data.code === 200) {
            let url = '/base/downloadWebData?fullpath=' + response.data.data
            this._downloadFile(url, 'Sequences.' + type)
          } else {
            this.$message.error(response.data.msg)
          }
        })
      }
    },
    judge (info, des) {
      var list = des.lineage.split('_')
      if (list[0] !== 'NA') {
        if (info.name === list[0]) {
          return true
        } else {
          return false
        }
      } else {
        var type = info.type.split('/')
        if (type[0] === list[1]) {
          return true
        } else {
          return false
        }
      }
    },
    renderTable (descriptionArray, posMsg, tableid, alignment, queryPos) {
      let cols = [
        { prop: 'max_score', label: 'Max score', width: 100 },
        { prop: 'query_cover', label: 'Query cover', width: 120 },
        { prop: 'evalue', label: 'Evalue', width: 80 },
        { prop: 'ident', label: 'Ident', width: 100 },
        {
          prop: 'accession',
          label: 'Accession',
          minWidth: 150
        }
      ]
      this.qulity = {
        datas: descriptionArray,
        cols: cols
      }
      this.assembly = ''
      // max_score,query_cover,evalue,ident,accession
      let header = cols.map(item => item.label)
      let body = descriptionArray.map(item => [item.max_score, item.query_cover, item.evalue, item.ident, '"' + item.accession + '"'].join(','))
      this.assembly = header.join(',') + '\n' + body.join('\n')
      this.qulityShow = false
      this.$nextTick(() => {
        this.qulityShow = true
      })
      this.retinue = {
        alignment: alignment,
        curlineDataPositions: this.curlineDataPositions,
        curStanardFeatureData: this.curStanardFeatureData,
        posMsg: posMsg,
        queryPos: queryPos
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
.banner {
  margin-top: vw(81);
  min-width: vw(1200);
  height: vw(356);
  background-image: url("../../assets/img/blast-banner.png");
  background-size: 100% 100%;
  padding-top: vw(130);
  box-sizing: border-box;
  div {
    width: vw(1200);
    margin: 0 auto;
    p {
      width: vw(900);
      font-size: vw(24);
      color: #333;
    }
  }
}
.path {
  color: #333;
  width: vw(1200);
  margin: vw(25) auto vw(52);
  font-size: vw(16);
  position: relative;
  a {
    color: #999;
    cursor: pointer;
    &:hover {
      color: $theme_color;
    }
  }
  .dropdown {
    position: absolute;
    top: 0;
    right: 0;
    >>> .el-input__inner {
      font-size: 16px;
      box-sizing: border-box;
    }
    >>> .el-select .el-input.is-focus .el-input__inner,
    >>> .el-select .el-input__inner:focus {
      border-color: $theme_color;
    }
  }
}
>>> .el-select-dropdown__item {
  padding-left: vw(10);
}
#classification-results {
  width: vw(1200);
  margin: 0 auto;

  .content {
    display: flex;
    padding: 15px;
    color: #666;
    box-sizing: border-box;
  }
  .le-title,
  .ri-content {
    padding: 9px 15px;
    line-height: 20px;
    float: left;
    display: block;
  }
  .le-title {
    color: #333;
    text-align: right;
    width: 44%;
    box-sizing: border-box;
    // width: vw(128);
  }
  .ri-content {
    color: #666;
    text-align: left;
    // word-wrap: break-word;
    word-break: break-all;
    box-sizing: border-box;
    width: 56%;
  }
  .line {
    width: 100%;
    overflow: hidden;
    font-size: 16px;
  }
  .el-bot {
    padding-top: vw(30);
    .zip-bot {
      padding: vw(12) vw(14) vw(12) vw(32);
      color: #606266;
      position: relative;
      img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: vw(10);
        width: vw(20);
        height: vw(20);
      }
    }
  }
  .downloadBtnContent {
    overflow: hidden;
    margin-bottom: 15px;
  }
  .downloadBtnContent a {
    text-decoration: underline;
    cursor: pointer;
    color: #409eff;
  }
}
.no-data {
  width: vw(1200);
  height: vw(400);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: vw(200);
  }
  p {
    margin-top: vw(20);
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/blast/blastResult.vue